var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2232 12.198C20.9492 10.1075 25.6634 11.4018 27.7996 15.1019L24.5847 16.9579C20.8418 19.1188 16.0545 17.8095 13.9326 14.0442L17.2232 12.198Z",
    fill: "#FF6665"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8605 10.7325C17.9889 7.04594 22.7031 5.78278 26.3897 7.91128L24.4629 11.249C22.3342 14.9356 17.6202 16.1988 13.9336 14.0702L15.8605 10.7325Z",
    fill: "#FF6665",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7666 10.3753C13.7666 5.90408 17.3913 2.27942 21.8624 2.27942V6.05749C21.8624 10.5286 18.2377 14.1533 13.7666 14.1533V10.3753Z",
    fill: "#FF6665",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8567 10.5293C9.72823 6.84265 10.9913 2.1285 14.6781 0L16.605 3.33766C18.7336 7.02434 17.4704 11.7385 13.7838 13.8669L11.8567 10.5293Z",
    fill: "#FF6665",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7665 9.83557C13.7665 5.66244 10.3836 2.27942 6.21045 2.27942V6.59721C6.21045 10.7704 9.59345 14.1533 13.7665 14.1533V9.83557Z",
    fill: "#FF6665",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1402 10.7325C10.0117 7.04594 5.29752 5.78278 1.61084 7.91128L3.53783 11.249C5.66634 14.9356 10.3805 16.1988 14.0671 14.0702L12.1402 10.7325Z",
    fill: "#FF6665",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7769 12.198C7.05103 10.1075 2.33682 11.4018 0.200684 15.1019L3.41543 16.9579C7.15848 19.1188 11.9458 17.8095 14.0677 14.0442L10.7769 12.198Z",
    fill: "#FF6665"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon03);
export default __webpack_public_path__ + "static/media/company-icon-03.1a07d29f9cee590b86e05cfffdcdb7e9.svg";
export { ForwardRef as ReactComponent };